import Swiper from 'swiper/bundle';
import gsap from 'gsap';

const app = {
  init() {
    this.setUpHeader();

    this.processStatsSliderModules();
    this.processCtaCardsModules();
    this.processUserReviewsModules();

    this.setUpRevealAnimations();
    this.setUpCounters();
  },

  $header: document.getElementById('main_header'),
  headerHideThreshold: tangleweb.currRootSize * 30,
  headerHideCounter: 0,
  headerVisible: true,
  prevScrollPos: window.scrollY,
  setUpHeader() {
    if (this.$header) {
      const headerRect = this.$header.getBoundingClientRect();

      window.addEventListener('scroll', () => {
        // 1 - down, 0 - up
        const dir = !!(this.prevScrollPos < window.scrollY);

        if ((window.scrollY <= headerRect.height && !this.headerVisible)
        || (!dir && !this.headerVisible)) {
          this.$header.classList.remove('hidden');
          this.headerVisible = true;
        } else if (dir) {
          if (this.headerHideCounter >= this.headerHideThreshold) {
            this.$header.classList.add('hidden');
            this.headerHideCounter = 0;
            this.headerVisible = false;
          }

          this.headerHideCounter++;
        }

        this.prevScrollPos = window.scrollY;
      });
    }
  },

  $statsModule: document.querySelectorAll('section.stats_slider'),
  processStatsSliderModules() {
    if (this.$statsModule && this.$statsModule.length) {
      this.$statsModule.forEach($module => {
        this.setUpStatsSlider($module);
      });
    }
  },
  setUpStatsSlider($module) {
    new Swiper($module.querySelector('.swiper'), {
      autoplay: {
        delay: 5000,
      },
      centeredSlides: true,
      initialSlide: 1,
      slidesPerView: 'auto',
      spaceBetween: tangleweb.currRootSize * 24,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-custom-button-next",
        prevEl: ".swiper-custom-button-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 0,
          centeredSlides: false,
          initialSlide: 0,
        }
      }
    });
  },

  $ctaCardsModule: document.querySelectorAll('section.cta_cards'),
  processCtaCardsModules() {
    if (this.$ctaCardsModule && this.$ctaCardsModule.length) {
      this.$ctaCardsModule.forEach($module => {
        this.setUpCtaCards($module);
      });
    }
  },
  setUpCtaCards($module) {
    new Swiper($module.querySelector('.swiper'), {
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 'auto',
      spaceBetween: tangleweb.currRootSize * 8,
      initialSlide: 1,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-custom-button-next",
        prevEl: ".swiper-custom-button-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 5,
          spaceBetween: tangleweb.currRootSize * 17, // 17rem
          initialSlide: 0,
          centeredSlides: false,
        }
      },
    });
  },

  $userReviewsModule: document.querySelectorAll('section.user_reviews'),
  processUserReviewsModules() {
    if (this.$userReviewsModule && this.$userReviewsModule.length) {
      this.$userReviewsModule.forEach($module => {
        this.setUpUserReviews($module);
      });
    }
  },
  setUpUserReviews($module) {
    new Swiper($module.querySelector('.swiper'), {
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: 1,
      spaceBetween: 0, // 50rem
      navigation: {
        nextEl: ".swiper-custom-button-next",
        prevEl: ".swiper-custom-button-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 'auto',
          centeredSlides: true,
          initialSlide: 1,
          spaceBetween: tangleweb.currRootSize * 50, // 50rem
        }
      },
    });
  },

  $revealEls: document.querySelectorAll('.fade-in,.slide-in'),
  setUpRevealAnimations() {
    if (this.$revealEls && this.$revealEls.length) {
      const observerOptions = {
        threshold: 1.0,
      };
      this.revealObserver = new IntersectionObserver(this.observeRevealEls.bind(this), observerOptions);

      // first figure out if the el is in view. If not then add active class
      this.$revealEls.forEach($el => {
        const elRect = $el.getBoundingClientRect();

        if (elRect.top > window.innerHeight || elRect.bottom < 0) {
          $el.classList.add('active');
          this.revealObserver.observe($el);
        }
      });

      // once all els processed, then set up the observer which will remove
      // added classes once the el scrolls into view
    }
  },

  setUpCounters() {
    const $blocks = document.querySelectorAll('section.victory_counter');

    if ($blocks.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(({isIntersecting, target}) => {
          if (isIntersecting) {
            const $number = target.querySelector('.counter');
            const animObj = {
              currCount: +$number.dataset.startamount
            };

            target.animated = false;

            gsap.to(animObj, {
              currCount: +$number.dataset.finalamount,
              duration: 3,
              ease: 'expo.out',
              onUpdate(self) {
                $number.textContent = '$' + Number(Math.round(animObj.currCount)).toLocaleString('en');
              }
            });
          }
        });
      });

      $blocks.forEach($block => {
        observer.observe($block);
      });
    }
  },

  observeRevealEls(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        gsap.to(entry.target, {
          opacity: 1,
          y: 0,
          onComplete() {
            entry.target.classList.remove('active', 'fade-in', 'slide-in');
            this.revealObserver.unobserve(entry.target);
          },
          callbackScope: this
        });
      }
    })
  }
};

app.init();